import { NEW_FOLDER_ID_PREFIX } from './media-manager-sdk/constants';

type TUniqueId = (prefix?: string) => string;

export const uniqueId: TUniqueId = (prefix = '') => `${prefix}${Date.now().toString(36)}`;

export const uniqueRandomId: TUniqueId = (prefix = '') =>
  `${prefix}${Math.ceil(Math.random() * Number.MAX_SAFE_INTEGER).toString(36)}`;

export const uniqueFolderId = () => uniqueId(NEW_FOLDER_ID_PREFIX);
